import { useMemo } from 'react';
import { useConfigStore } from '../store/config-store.js';
import { Activity, Grid3x3, Radio, Users } from 'lucide-react';

export function DashboardPage(): JSX.Element {
  const draft = useConfigStore((s) => s.draft);
  const live = useConfigStore((s) => s.live);
  const diff = useConfigStore((s) => s.diff);

  const stats = useMemo(() => {
    const panels = draft?.panels.length ?? 0;
    const partylines = draft?.partylines.length ?? 0;
    const buttons = draft?.buttons.length ?? 0;
    const liveVersion = live?.version ?? 0;
    return { panels, partylines, buttons, liveVersion };
  }, [draft, live]);

  return (
    <div className="p-6 space-y-6">
      <header>
        <h1 className="text-xl font-semibold text-text">Dashboard</h1>
        <p className="text-sm text-text-dim mt-1">
          Überblick über deine Intercom-Topologie.
        </p>
      </header>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        <StatCard icon={<Grid3x3 size={16} />} label="Panels" value={stats.panels} />
        <StatCard icon={<Radio size={16} />} label="Partylines" value={stats.partylines} />
        <StatCard icon={<Users size={16} />} label="Button-Links" value={stats.buttons} />
        <StatCard
          icon={<Activity size={16} />}
          label="Live-Version"
          value={`v${stats.liveVersion}`}
        />
      </div>

      {diff && diff.totalChanges > 0 ? (
        <section className="card p-5">
          <h2 className="text-sm font-semibold text-text mb-2">
            Ausstehende Änderungen
          </h2>
          <p className="text-sm text-text-dim">
            {diff.totalChanges} Änderung{diff.totalChanges === 1 ? '' : 'en'} im Draft.
            Über die Push-Leiste unten live schalten.
          </p>
        </section>
      ) : (
        <section className="card p-5">
          <h2 className="text-sm font-semibold text-text mb-2">Status</h2>
          <p className="text-sm text-text-dim">
            Draft und Live sind identisch — alles synchronisiert.
          </p>
        </section>
      )}
    </div>
  );
}

function StatCard({
  icon,
  label,
  value,
}: {
  icon: JSX.Element;
  label: string;
  value: number | string;
}): JSX.Element {
  return (
    <div className="card p-4 flex items-center gap-3">
      <div className="w-9 h-9 rounded-btn bg-elev flex items-center justify-center text-text-dim">
        {icon}
      </div>
      <div>
        <div className="label-sm">{label}</div>
        <div className="text-lg font-semibold text-text leading-tight">{value}</div>
      </div>
    </div>
  );
}
